<template>
  <return-over-limlt-check> </return-over-limlt-check>
</template>

<script>
import returnOverLimltCheck from '@/views/workbench/workCheckManage/returnOverLimltCheck/returnOverLimltCheck'
import checkMixin from '@/mixin/checkMixin'
import routerMixin from '@/mixin/routerMixin'
export default {
  name: 'returnOverLimltCheckView',
  mixins: [checkMixin],
  components: {
    returnOverLimltCheck
  }
}
</script>

<style scoped></style>
